function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0.43,84.657 0,94.161 3.032,101.3 1.95,111.461 4.537,113.622 7.135,112.106 24.439,133.07  28.104,135.248 28.538,147.129 31.784,150.382 44.536,125.949 49.08,103.89 57.73,103.464 66.373,111.461 66.373,124.867  69.619,134.593 76.762,135.678 83.899,143.244 89.084,143.893 119.563,109.292 123.675,109.951 126.271,103.464 131.894,101.726  133.4,105.623 138.602,107.14 143.784,106.053 146.82,116.434 151.787,116.866 156.538,123.349 154.378,132.004 165.616,134.593  165.616,136.323 173.831,139.568 172.319,143.893 200,141.73 196.32,93.09 184.646,93.09 162.589,84.007 157.41,88.328  158.054,95.893 155.026,98.491 139.024,98.491 132.978,90.924 128.43,90.924 127.782,88.978 120.215,84.657 118.703,61.949  108.32,59.792 101.834,49.619 94.058,52.864 88.432,52.864 70.048,66.279 43.028,66.705 "
});

var Svg27 = function Svg27(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TAB",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg27, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/27.4040405f.svg";
export { ForwardRef as ReactComponent };